// extracted by mini-css-extract-plugin
export default {"AuditLog":"styles_AuditLog__YBAnQ"};